"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var UserDetails_1 = require("./UserDetails");
var UserDetailsWrapper = function (_a) {
    var userInformation = _a.userInformation, paymentInformation = _a.paymentInformation;
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var paymentInfo = paymentInformation !== null && ((_b = paymentInformation) === null || _b === void 0 ? void 0 : _b.transactions.length)
        ? __spreadArrays((_c = paymentInformation) === null || _c === void 0 ? void 0 : _c.transactions).pop()
        : null;
    return (userInformation && (<>
        <UserDetails_1.default firstname={(_e = (_d = userInformation) === null || _d === void 0 ? void 0 : _d.user) === null || _e === void 0 ? void 0 : _e.firstname} lastname={(_g = (_f = userInformation) === null || _f === void 0 ? void 0 : _f.user) === null || _g === void 0 ? void 0 : _g.lastname} email={(_j = (_h = userInformation) === null || _h === void 0 ? void 0 : _h.user) === null || _j === void 0 ? void 0 : _j.email} telephone={(_l = (_k = userInformation) === null || _k === void 0 ? void 0 : _k.user) === null || _l === void 0 ? void 0 : _l.telephone} reservationContact={(_o = (_m = userInformation) === null || _m === void 0 ? void 0 : _m.user) === null || _o === void 0 ? void 0 : _o.reservationContact} transactionDetails={paymentInfo}/>
      </>));
};
exports.default = UserDetailsWrapper;
